import { c as _c } from "react/compiler-runtime";
import { getEntriesOfContentType } from "@/lib/contentful/guards";
import { FooterNavLink, type FooterNavLinkEntry } from "./FooterNavLink";
interface Props {
  legalLinks: unknown[];
}
export function FooterLegalBar(t0) {
  const $ = _c(19);
  const {
    legalLinks
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let year;
  if ($[0] !== legalLinks) {
    const links = getEntriesOfContentType(legalLinks, "footerNavLinks");
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = new Date().getFullYear();
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    year = t5;
    t4 = "mx-auto flex w-full max-w-site-content flex-col items-start gap-2 p-12 md:flex-row md:items-center md:justify-between md:px-12 md:py-5";
    t3 = "Legal";
    t1 = "flex flex-col gap-2 md:flex-row md:flex-wrap md:items-center md:gap-x-6";
    t2 = links.map(_temp);
    $[0] = legalLinks;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = year;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    year = $[5];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t2) {
    t5 = <ul className={t1}>{t2}</ul>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <nav aria-label={t3}>{t5}</nav>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== year) {
    t7 = <p className="text-sm font-medium leading-normal">Copyright © {year} StickerGiant.com Inc. All rights reserved.</p>;
    $[13] = year;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t7) {
    t8 = <div className={t4}>{t6}{t7}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}
function _temp(link, index) {
  return <FooterNavLink key={`${link.sys.id}-${index}`} link={link} />;
}